import type { $OpenApiTs } from 'app/API';

export type TAuditLogsListParams = $OpenApiTs['/api/admin/audit-logs']['get']['req'];

export const auditLogsKeys = {
  all: [{ module: 'auditLogs' }] as const,
  entityTypes: () => [{ ...auditLogsKeys.all[0], scope: 'entityTypes' }] as const,
  lists: () => [{ ...auditLogsKeys.all[0], scope: 'list' }] as const,
  list: (params: TAuditLogsListParams) => [{ ...auditLogsKeys.lists()[0], params }] as const,
};
